import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@aid/auth/services';

@Injectable({
  providedIn: 'root'
})
export class NotLoggedInGuard {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const accessToken = localStorage.getItem(AuthService.ACCESS_TOKEN_KEY);
    const refreshToken = localStorage.getItem(AuthService.REFRESH_TOKEN_KEY);

    if (state.url.indexOf('/connect-user') >= 0) {
      return true;
    }
    if (!(accessToken && refreshToken)) {
      return true;
    }

    this.router.navigate(['']);
    return false;
  }
}
